import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {AuthGuard} from '../shared/guards/auth.guard';
import {WizardGuard} from '../shared/guards/wizard.guard';
import {PricingComponent} from './components/pricing/pricing.component';
import {NoPricingGuard} from '../shared/guards/noPricing.guard';
import {SuccessfulPaymentComponent} from './components/successful-payment/successful-payment.component';
import {PricingGuard} from '../shared/guards/pricing.guard';
import {CancelPaymentComponent} from './components/cancel-payment/cancel-payment.component';

const routes: Routes = [
    {
        path: '',
        component: PricingComponent,
        canActivate: [AuthGuard, WizardGuard] // NoPricingGuard
    },
    {
        path: 'success',
        component: SuccessfulPaymentComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    },
    {
        path: 'cancel',
        component: CancelPaymentComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PricingRoutingModule {
}
